import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import WatchInfo from './WatchInfo'
import './SalesDesk.css'
import Logo from './../../assets/zeitauktion-logo_preowned-luxury-watches.svg'
import QuickPick from '../QuickPick/QuickPickMain'
//import BlueBrain from './../../assets/BigBrainLogo.png'
import CustomerInfo from '../SalesDesk/CustomerInfo'
import Checkout from '../SalesDesk/Checkout'
import { Button } from 'reactstrap'
export default function SalesDesk(props) {
    const [pickup, setPickup] = useState(false);
    const toggle = () => {
        setPickup(!pickup)
    };
    const location = useLocation();
    return (
        <div className="container mb-5">
            <header className=" d-flex justify-content-between align-items-center p-4 mb-5 w-xl">
                <h2>Sales Desk 
                    {/** {location.state.param1}*/}
                </h2>
                <img src={Logo} alt="Zeitauktion" />
                <h2><a href="/">Blue Brain</a></h2>
            </header>
            <WatchInfo />
            <div className="d-flex justify-content-around align-items-center">
                {/* <div className="col-md-5 pt-5 mt-2">
                    <CustomerInfo />
                </div>
                */}
                <div className="col-md-6 pt-5 mt-2">
                    <Checkout />
                </div>
            </div>
            <hr className="mt-5 mb-5" />
            <Button onClick={toggle} className="mb-5">Pick up handler</Button>
            {pickup &&
                <QuickPick />
            }
        </div>
    )
}
